// components/Auth/LoginModal.jsx
'use client'
import { useEffect, useRef } from 'react'
import LoginPanel from './LoginPanel'

// Rendered once by <UserProvider>; open it anywhere with useUser().openLogin()
export default function LoginModal({ open, onClose, lang = 'en', callbackUrl }) {
  const dialogRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    dialogRef.current?.focus()
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prevOverflow
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      animation: 'navFadeIn 0.15s ease',
    }}>
      <div ref={dialogRef} role="dialog" aria-modal="true" aria-label="Log in" tabIndex={-1}
        dir={['he', 'ar', 'fa', 'ur'].includes(lang) ? 'rtl' : 'ltr'}
        onClick={e => e.stopPropagation()}
        style={{
          position: 'relative', width: '100%', maxWidth: 400, background: '#fff',
          borderRadius: 12, padding: '28px 24px 24px', boxShadow: '0 20px 48px rgba(0,0,0,0.2)', outline: 'none',
        }}>
        <button onClick={onClose} aria-label="Close" style={{
          position: 'absolute', top: 12, insetInlineEnd: 12, background: 'none', border: 'none',
          cursor: 'pointer', padding: 6, color: '#6b7280', lineHeight: 1,
        }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        <LoginPanel lang={lang} callbackUrl={callbackUrl} />
      </div>
    </div>
  )
}